type OrganizationLike = {
  name?: string | null;
};

export const sortOrganizationsByName = <T extends OrganizationLike>(
  organizations: T[],
  locale?: string,
): T[] =>
  [...organizations].sort((a, b) =>
    (a.name || '').localeCompare(b.name || '', locale, {
      numeric: true,
      sensitivity: 'base',
    }),
  );
